/* eslint-disable solid/no-innerhtml */

const SIZE_CLASSES = Object.freeze({
  xs: "tw:w-3 tw:h-3",
  sm: "tw:w-4 tw:h-4",
  md: "tw:w-6 tw:h-6",
});

/**
 * @param {object} props Component props
 * @param {string} [props.className] Additional CSS classes
 * @param {string} props.svg Raw SVG string to render
 * @param {"xs" | "sm" | "md"} [props.size] Icon size (default: "md")
 * @returns {import('solid-js').JSX.Element} Icon element
 */
export function UIIcon(props) {
  const sizeClass = () => SIZE_CLASSES[props.size || "md"];

  return (
    <div
      innerHTML={props.svg}
      className={`${sizeClass()} ${props.className || ""}`}
    />
  );
}
